module.exports = __webpack_public_path__ + "img/lg_ring_r_0_1_null@3x.891a6b72.png";